import { TREE_MIN_WIDTH } from '~src/config';
import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';
import {
  LEFT_SIDEBAR_WIDTH_CSS,
  RIGHT_BLOCK_WIDTH_CSS,
} from '~src/styles/constants';

export const styleFn: ThemedStyleFn = (theme) => ({
  leftContainer: {
    minWidth: TREE_MIN_WIDTH,
    width: LEFT_SIDEBAR_WIDTH_CSS,
    height: '100%',
    borderRight: `solid 1px ${theme.colors.darkGray}`,
  },
  leftTreeContainer: {
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    padding: 5,
    overflow: 'auto',
  },
  leftTreeIcon: {
    fontSize: '20px',
    transition: '0.3s',
    margin: '3px 0 10px -16px',
  },
  rightContainer: {
    width: RIGHT_BLOCK_WIDTH_CSS,
    maxWidth: `calc(100vw - ${TREE_MIN_WIDTH}px)`,
    height: '100%',
    position: 'relative',
  },
  rightHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.gray,
    margin: '0 5px',
    minHeight: '40px',
    borderBottom: `1px solid ${theme.colors.darkGray}`,
  },
  headline: {
    color: theme.colors.text.primary,
    fontWeight: 'bold',
    padding: 5,
  },
  headerIcon: {
    color: theme.colors.secondary,
    fontSize: '18px',
    margin: '0 5px',
  },
  typeIcon: {
    color: theme.colors.secondary,
    fontSize: '20px',
    margin: '0 2px',
  },
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
  },
  fullScreen: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonsContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    boxShadow: '0 0 5px rgba(0,0,0,.2)',
    padding: 8,
    width: '100%',
    textAlign: 'center',
    animation: `${fadeInKeyframes} 0.3s ease-out`,
    background: 'white',
  },
  button: {
    margin: 15,
  },
  headerPadding: {
    paddingBottom: 10,
  },
});
